import React, { createContext, useContext, useState, useEffect } from 'react';
import en from '../locales/en';
import zh from '../locales/zh';

// 创建语言上下文
const LanguageContext = createContext();

// 支持的语言
export const SUPPORTED_LANGUAGES = {
  en: {
    name: 'English',
    flag: '🇺🇸',
    locale: en
  },
  zh: {
    name: '中文',
    flag: '🇨🇳',
    locale: zh
  }
};

// 语言提供者组件
export const LanguageProvider = ({ children }) => {
  // 默认使用英文
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [translations, setTranslations] = useState(SUPPORTED_LANGUAGES.en.locale);

  // 从本地存储加载语言设置
  useEffect(() => {
    const savedLanguage = localStorage.getItem('wevoov-language');
    if (savedLanguage && SUPPORTED_LANGUAGES[savedLanguage]) {
      setCurrentLanguage(savedLanguage);
      setTranslations(SUPPORTED_LANGUAGES[savedLanguage].locale);
    }
  }, []);

  // 切换语言
  const changeLanguage = (languageCode) => {
    if (SUPPORTED_LANGUAGES[languageCode]) {
      setCurrentLanguage(languageCode);
      setTranslations(SUPPORTED_LANGUAGES[languageCode].locale);
      localStorage.setItem('wevoov-language', languageCode);
    }
  };

  // 获取翻译文本
  const t = (key) => {
    const keys = key.split('.');
    let value = translations;
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        console.warn(`Translation key not found: ${key}`);
        return key;
      }
    }
    
    return value;
  };

  const value = {
    currentLanguage,
    translations,
    changeLanguage,
    t,
    supportedLanguages: SUPPORTED_LANGUAGES
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

// 自定义 Hook 来使用语言上下文
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}; 